export default __webpack_public_path__ + "static/media/solidstar.4cf58c3d.svg";